module.exports = __webpack_public_path__ + "static/oghma-DND3_FnP-07ab3e0c56635c757efb3b819c0d7eac.jpg";